import React, { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useMatchMedia } from '@rst/libs-ts'
import { TemplateProps } from '../type'
import { TemplateMobile } from './mobile'
import { TemplateDesktop } from './desktop'

export const Template: React.FC<TemplateProps> = props => {
	useEffect(() => {
		return () => {
			if (props.onUnmount) props.onUnmount()
		}
	}, [])

	const sm = useMatchMedia(x => x.less.sm)
	const target = document.querySelector('#awesome-modal-root')

	if (!target) {
		console.error("Создайте div с id='awesome-modal-root' для работы Modal2")
		return null
	}
	return createPortal(
		sm ? <TemplateMobile {...props} /> : <TemplateDesktop {...props} />,
		target
	)
}
